import React from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { actions, asyncGetThermograms } from '../../../model';
import styles from './style.css';
import List from './List/';
import DevList from './DevList/';
import HotList from './HotList/';
import hotRender, { clearAllThermograms } from './HotList/hotRender';
import updateAllChips from '../../../utils/updateAllChips';
import params from '../../../utils/params';

import isDevMode from '../../../utils/isDevMode';

class SiderTools extends React.PureComponent {
    static propTypes = {
        uiStateUpdate: PropTypes.func,
        listIsShow: PropTypes.bool,
        devListIsShow: PropTypes.bool,
        isPreviewAll: PropTypes.bool,
        allChipsUpdate: PropTypes.func,
        openDialogCallback: PropTypes.func,
        rqCode: PropTypes.object,
        asyncGetThermograms: PropTypes.func,
        thermogramListIsShow: PropTypes.bool,
        isThermogram: PropTypes.bool,
        isThermogramOpen: PropTypes.bool,
    };

    listHandle = () => {
        this.props.uiStateUpdate({
            listIsShow: !this.props.listIsShow,
            devListIsShow: false,
            thermogramListIsShow: false,
        });
    };
    previewHandle = () => {
        this.props.uiStateUpdate({
            isPreviewAll: !this.props.isPreviewAll,
            isThermogram: false,
            listIsShow: !this.props.isPreviewAll ? false : this.props.listIsShow,
            devListIsShow: !this.props.isPreviewAll ? false : this.props.devListIsShow,
        });
        updateAllChips();
    };
    refreshHandle = () => {
        this.props.allChipsUpdate();
    };

    devListHandle = () => {
        this.props.uiStateUpdate({
            listIsShow: false,
            thermogramListIsShow: false,
            devListIsShow: !this.props.devListIsShow,
        });
    };

    thermogramHandle = async () => {
        this.props.uiStateUpdate({
            thermogramListIsShow: !this.props.thermogramListIsShow,
            isPreviewAll: !this.props.isThermogram,
            isThermogram: !this.props.isThermogram,
            listIsShow: false,
            devListIsShow: false,
        });
        if (!this.props.isThermogram) {
            params.add('hot', 'true');
            await this.props.asyncGetThermograms();
            hotRender();
        } else {
            params.del('hot');
            clearAllThermograms();
            updateAllChips();
        }
    };

    previewQrcodeHandle = () => {};
    render() {
        return (
            <f-div>
                <f-div class={styles.tools}>
                    {!this.props.isThermogram ? (
                        <React.Fragment>
                            <f-div class={styles.iconFragment} title="碎片列表" onClick={this.listHandle} />
                            <f-div class={styles.iconPreview} title="预览" onClick={this.previewHandle} />
                            <f-div class={styles.iconRefresh} title="刷新" onClick={this.refreshHandle} />
                            <f-div class={styles.iconPreviewQrcode} title="预览二维码">
                                <f-div class={styles.qrCode}>
                                    <f-div class={styles.qrCodeTitle}>手机预览二维码</f-div>
                                    <f-div
                                        class={styles.qrCodeImg}
                                        style={{
                                            backgroundImage: `url(${this.props.rqCode.preview})`,
                                        }}
                                    />
                                </f-div>
                            </f-div>
                            <f-div class={styles.iconMobileQrcode} title="上线手机二维码">
                                <f-div class={styles.qrCode}>
                                    <f-div class={styles.qrCodeTitle}>上线预览二维码</f-div>
                                    <f-div
                                        class={styles.qrCodeImg}
                                        style={{
                                            backgroundImage: `url(${this.props.rqCode.online})`,
                                        }}
                                    />
                                </f-div>
                            </f-div>
                            <f-div class={styles.iconAppQrcode} title="客户端预览二维码">
                                <f-div class={styles.qrCode}>
                                    <f-div class={styles.qrCodeTitle}>客户端预览二维码</f-div>
                                    <f-div
                                        class={styles.qrCodeImg}
                                        style={{
                                            backgroundImage: `url(${this.props.rqCode.appPreview})`,
                                        }}
                                    />
                                </f-div>
                            </f-div>
                            {isDevMode() ? (
                                <f-div class={styles.iconDev} title="开发" onClick={this.devListHandle} />
                            ) : null}
                        </React.Fragment>
                    ) : null}
                    {this.props.isThermogramOpen ? (
                        <f-div
                            onClick={this.thermogramHandle}
                            class={this.props.isThermogram ? styles.iconThermogramActive : styles.iconThermogram}
                            title="热图"
                        />
                    ) : null}
                </f-div>
                <List openDialogCallback={this.props.openDialogCallback} />
                <DevList openDialogCallback={this.props.openDialogCallback} />
                {this.props.isThermogramOpen ? <HotList /> : null}
            </f-div>
        );
    }
}

const mapStateToProps = state => ({
    listIsShow: state.uiState.listIsShow,
    devListIsShow: state.uiState.devListIsShow,
    thermogramListIsShow: state.uiState.thermogramListIsShow,
    isPreviewAll: state.uiState.isPreviewAll,
    isThermogram: state.uiState.isThermogram,
    isThermogramOpen: state.uiState.isThermogramOpen,
    rqCode: state.rqCode,
    thermograms: state.thermograms,
});

const mapDispatchToProps = dispatch => ({
    uiStateUpdate: data => dispatch(actions.uiStateUpdate(data)),
    allChipsUpdate: () => dispatch(actions.allChipsUpdate()),
    asyncGetThermograms: () => dispatch(asyncGetThermograms()),
});

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(SiderTools);
